const state = {
  completeEmail: null,
  selectionEmail: null
};

const getters = {
  getSelectionEmail: state => state.selectionEmail,
  getCompleteEmail: state => state.completeEmail
};

const mutations = {
  setSelectionEmail(state, selectionEmail) {
    state.selectionEmail = selectionEmail;
  },
  setCompleteEmail(state, completeEmail) {
    state.completeEmail = completeEmail;
  }
};

const actions = {
  getSelectionEmail({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await axios.get(
          `/api/v3/insurances/applications/${payload.application_id}/selections`,
          {
            headers: {
              Authorization: `Bearer ${payload.token}`
            }
          }
        );
        commit("setSelectionEmail", res.data);
        resolve(res);
      } catch (err) {
        reject(err);
      }
    });
  },
  getCompleteEmail({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await axios.get(
          `/api/v3/insurances/applications/${payload.application_id}/complete`,
          {
            headers: {
              Authorization: `Bearer ${payload.token}`
            }
          }
        );
        commit("setCompleteEmail", res.data);
        resolve(res);
      } catch (err) {
        reject(err);
      }
    });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
